<template>
  <div id="app" :style="cssProps">
    <div :class="{ overlay: overlay }"></div>
    <div v-loading.fullscreen.lock="showLoader">
      <router-view />
    </div>
  </div>
</template>
<script>
// import { USER_REQUEST } from '@/store/actions/user'
import { mapState, mapGetters } from 'vuex';
import { refreshToken } from '@/utils/echoApi';
export default {
  name: 'App',
  data() {
    return {
      isActive: false,
      windowWidth: 0,
      windowHeight: 0,
      refreshTokenInterval: null
    };
  },
  // created: function () {
  //   if (this.$store.getters.isAuthenticated) {
  //     this.$store.dispatch(USER_REQUEST)
  //   }
  // },
  computed: {
    ...mapGetters('data', ['AppLoadedGetter']),
    ...mapState('menu', {
      overlay: state => state.overlay
    }),
    ...mapState({
      primaryColor: state => state.app.primaryColor
    }),
    ...mapState({
      secondaryColor: state => state.app.secondaryColor
    }),
    cssProps() {
      return {
        '--main-color': this.primaryColor,
        '--secondary-color': this.secondaryColor
      };
    },
    showLoader() {
      if (!this.$route.name || !this.$route.name === 'Login') {
        return !this.AppLoadedGetter;
      }
    }
  },
  watch: {
    windowWidth() {
      this.storeWindowWidth(this.windowWidth);
      // if (this.windowWidth < 750) {
      //   this.isActive = true
      // } else {
      //   this.isActive = false
      // }
    }
  },
  mounted() {
    // console.log('this.$route.name', this.$route.name);
    this.$nextTick(function() {
      window.addEventListener('resize', this.getWindowWidth);
      window.addEventListener('resize', this.getWindowHeight);

      // Init
      this.getWindowWidth();
      this.getWindowHeight();
      this.setPrimaryColor();
      this.setSecondaryColor();
      // this.setApiPage();
    });
    // getting refresh token every 55 minutes;
    this.refreshTokenInterval = setInterval(() => {
      // console.log('RT');
      refreshToken();
    }, 3300000);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
    window.removeEventListener('resize', this.getWindowHeight);
    clearInterval(this.refreshTokenInterval);
  },
  methods: {
    // setApiPage () {
    //   this.$store.state.data.ApiPage = true;
    // },
    getWindowWidth: function() {
      this.windowWidth = document.documentElement.clientWidth;
    },
    getWindowHeight: function() {
      this.windowHeight = document.documentElement.clientHeight;
    },
    storeWindowWidth: function(key) {
      this.$store.state.window.size = key;
    },

    // when changing primary and secondary color code, must change also color codes on variables.scss
    setPrimaryColor() {
      this.$store.dispatch('setPrimaryColor', '#43B000');
    },
    setSecondaryColor() {
      this.$store.dispatch('setSecondaryColor', '#75b92a');
    },
    generateColor() {
      // Generate Random Hex Color
      var length = 6;
      var chars = '0123456789ABCDEF';
      var hex = '#';
      while (length--) hex += chars[(Math.random() * 16) | 0];
      return hex;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue